<template>
  <div class="shortform-marketing-container">
    <div class="shortform-marketing-content">
      <div class="shortform-marketing-detail">
        <!-- Header -->
        <div :class="$vuetify.breakpoint.mdAndUp ? 'header mb-6' : 'header mb-4'">
          <div :class="$vuetify.breakpoint.mdAndUp ? 'header-title mb-2' : 'header-title mb-1'">
            누적 조회수 1억뷰 달성!
          </div>

          <div :class="$vuetify.breakpoint.mdAndUp ? 'logo-section mb-4' : 'logo-section mb-2'">
            <div class="play-icon">
              <svg
                :width="$vuetify.breakpoint.mdAndUp ? '21' : '15'"
                :height="$vuetify.breakpoint.mdAndUp ? '21' : '15'"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 2L13.3333 8L4 14V2Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <h1 class="main-title">숏폼 마케팅</h1>
          </div>

          <p class="description">
            인스타그램 릴스, 틱톡, 쇼츠 등을 활용한 전문적인 인플루언서
            <span class="desktop"> </span>
            마케팅으로 브랜드 인지도를 폭발적으로 증가시킵니다.
          </p>
        </div>

        <!-- Process Section -->
        <div class="process-section">
          <h3 :class="$vuetify.breakpoint.mdAndUp ? 'process-title mb-4' : 'process-title mb-2'">
            숏폼 마케팅 프로세스
          </h3>

          <div class="process-steps">
            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-1-box</v-icon>
              <div class="step-content">
                <h4>트렌드 분석</h4>
                <p>인플루언서별 고성과 콘텐츠 분석</p>
              </div>
            </div>

            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-2-box</v-icon>
              <div class="step-content">
                <h4>콘텐츠 제작</h4>
                <p>브랜드 맞춤형 크리에이티브 콘텐츠 제작</p>
              </div>
            </div>

            <div class="step-item">
              <v-icon color="#3895FF" size="24">mdi-numeric-3-box</v-icon>
              <div class="step-content">
                <h4>배포 및 최적화</h4>
                <p>다채널 동시 배포 및 성과 최적화</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shortform-marketing-image">
        <img
          v-if="$vuetify.breakpoint.mdAndUp"
          width="100%"
          height="100%"
          src="@/assets/img/campaign/export-voucher/shortform-desktop.png"
          alt="shortform-marketing-image" />
        <img
          v-else
          width="100%"
          height="100%"
          src="@/assets/img/campaign/export-voucher/shortform-mobile.png"
          alt="shortform-marketing-image" />
      </div>
    </div>

    <div class="shortform-example">
      <div class="shortform-example-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
          <path d="M13.8562 0.164551L6.92812 12.1646L0 0.164551H13.8562Z" fill="black" />
        </svg>
        진행 사례
      </div>
      <!-- 진행 사례 섹션 -->
      <div class="case-studies-section" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div
          class="slider-container"
          @mousedown="startDrag"
          @mousemove="drag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          @touchstart="startDrag"
          @touchmove="drag"
          @touchend="endDrag"
          @touchcancel="endDrag">
          <!-- 슬라이더 -->
          <div class="slider-wrapper">
            <div class="slider-track" :style="{ transform: `translateX(${slideOffset}px)` }">
              <div class="case-item" v-for="(item, index) in caseItems" :key="index">
                <div class="case-image">
                  <img :src="item.image" :alt="item.title" draggable="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shortformMarketingDetail',
  data() {
    return {
      showNavButtons: false,
      currentSlide: 0,
      slideOffset: 0,
      itemWidth: 240 + 12, // 카드 너비 + 간격
      isDragging: false,
      startX: 0,
      startOffset: 0,
      autoSlideInterval: null,
      isAutoSliding: true,
      caseItems: [
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-1.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-2.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-3.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-4.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-5.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-6.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-7.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-1.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-2.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-3.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-4.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-5.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-6.png'),
        },
        {
          image: require('@/assets/img/campaign/export-voucher/short-form-example/short-form-example-7.png'),
        },
      ],
    };
  },
  computed: {
    maxSlide() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return Math.max(0, this.caseItems.length - 4); // 한 번에 4개씩 보여줌
      } else {
        return Math.max(0, this.caseItems.length - 2);
      }
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeDestroy() {
    this.stopAutoSlide();
  },
  methods: {
    startAutoSlide() {
      this.stopAutoSlide(); // 기존 interval 정리
      this.autoSlideInterval = setInterval(() => {
        if (this.isAutoSliding) {
          this.autoSlide();
        }
      }, 2000);
    },
    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    },
    pauseAutoSlide() {
      this.isAutoSliding = false;
    },
    resumeAutoSlide() {
      this.isAutoSliding = true;
    },
    autoSlide() {
      if (this.currentSlide < this.maxSlide) {
        this.currentSlide++;
      } else {
        this.currentSlide = 0; // 마지막 슬라이드에서 첫 번째로 돌아감
      }
      this.slideOffset = -this.currentSlide * this.itemWidth;
    },

    startDrag(e) {
      this.pauseAutoSlide();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this.isDragging = true;
      this.startX = clientX;
      this.startOffset = this.slideOffset;

      if (e.touches) {
        e.preventDefault();
      }
    },
    drag(e) {
      if (!this.isDragging) return;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = clientX - this.startX;
      const newOffset = this.startOffset + deltaX;

      // 드래그 범위 제한
      const minOffset = -this.maxSlide * this.itemWidth;
      const maxOffset = 0;

      this.slideOffset = Math.max(minOffset, Math.min(maxOffset, newOffset));

      if (e.touches) {
        e.preventDefault();
      }
    },
    endDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;

      // 드래그 종료 후 현재 위치에 가장 가까운 슬라이드로 스냅
      const slideIndex = Math.round(-this.slideOffset / this.itemWidth);
      this.currentSlide = Math.max(0, Math.min(this.maxSlide, slideIndex));
      this.slideOffset = -this.currentSlide * this.itemWidth;

      // 3초 후 자동 슬라이드 재시작
      setTimeout(() => {
        this.resumeAutoSlide();
      }, 3000);
    },
    onMouseEnter() {
      this.showNavButtons = true;
      this.pauseAutoSlide();
    },
    onMouseLeave() {
      this.showNavButtons = false;
      this.resumeAutoSlide();
    },
  },
};
</script>

<style scoped lang="scss">
.shortform-marketing-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9fbff;
  padding: 100px 16px;
  gap: 40px;

  @media (max-width: 960px) {
    padding: 56px 16px;
    gap: 24px;
  }
}

.shortform-marketing-content {
  width: 100%;
  max-width: 1072px;
  display: flex;
  gap: 40px;

  @media (max-width: 960px) {
    flex-direction: column;
    gap: 16px;
  }
}

.shortform-marketing-detail {
  display: flex;
  flex-direction: column;
}

.header {
  margin-bottom: 48px;
}

.header-title {
  color: #f53c4b;

  font-size: 18px;
  font-weight: 700;
  line-height: 28px; /* 155.556% */

  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.play-icon {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #e91e63 0%, #ff6b9d 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 960px) {
    width: 30px;
    height: 30px;
  }
}

.main-title {
  color: #21232e;
  text-align: center;
  font-size: 30px;
  font-weight: 800;
  line-height: 42px; /* 140% */

  @media (max-width: 960px) {
    font-size: 24px;
    line-height: 30px;
  }
}

.description {
  color: #4b5563;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px; /* 155.556% */

  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px; /* 171% */
  }
}

.process-section {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 480px;

  @media (max-width: 960px) {
    width: 100%;
    padding: 16px;
  }
}

.process-title {
  color: #1b2b43;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.6px;
}

.process-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.step-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f9fbff;
  border-radius: 8px;

  @media (max-width: 960px) {
    padding: 8px;
    gap: 8px;
  }
}

.step-content {
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.step-content h4 {
  color: #1f2937;
  width: 110px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.step-content p {
  color: #4b5563;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}

.shortform-marketing-image {
  width: 100%;
  max-width: 552px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}

.shortform-example {
  width: 1072px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  @media (max-width: 960px) {
    width: 100%;
  }
}

.shortform-example-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #21232e;
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  @media (max-width: 960px) {
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
  }
}

/* 진행 사례 슬라이더 스타일 */
.case-studies-section {
  width: 100%;
  height: 360px;
  margin-top: 24px;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  background: #fff;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.3s ease;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.nav-button.visible {
  opacity: 1;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.nav-button-left {
  left: 10px;
}

.nav-button-right {
  right: 10px;
}

.slider-wrapper {
  width: 100%;
  height: 100%;
  cursor: grab;
}

.slider-wrapper:active {
  cursor: grabbing;
}

.slider-track {
  display: flex;
  gap: 16px;
  transition: transform 0.3s ease;
  will-change: transform;
}

.case-item {
  width: 234px;
  height: 360px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  flex: 0 0 234px;
}

.case-image {
  position: relative;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
}

.case-content {
  padding: 16px;
}

/* 모바일 반응형 */
@media (max-width: 960px) {
  .case-item {
    flex: 0 0 240px;
  }

  .slider-track {
    gap: 12px;
  }
}
</style>
